import type { LocalEditorEvent, LocalEditorRequest } from '@playcastdotio/Messaging';
import type { LocalCampaignPublishRequest, LocalCampaignPublishResponse } from '@playcastdotio/Messaging';

const requestChannel = 'macro-editor:request';
const eventChannel = 'macro-editor:event';
const publishRequestChannel = 'macro-editor:publish-request';
const publishResultChannel = 'macro-editor:publish-result';

export interface LocalHostCampaignPublishFrame {
  requestId: string; clientId: string; sessionId: string; request: LocalCampaignPublishRequest;
  packages: LocalCampaignPublishResponse['packages'];
}
export type LocalHostCampaignPublishIpcFrame = LocalHostCampaignPublishFrame;
export type LocalHostRendererFrame = { clientId: string; request: LocalEditorRequest; playjectorConnected: boolean;
  /** Main-process ownership is authoritative; false lets the renderer reclaim an orphaned in-memory session. */
  activeSessionClaimed?: boolean; serverOwned?: true }
  | { clientId: string; publish: LocalHostCampaignPublishFrame }
  | { clientId: string; disconnected: true };

export class LocalHostApiRendererService {
  public subscribe(listener: (frame: LocalHostRendererFrame) => void): void {
    const ipc = window.playcast?.ipc;
    if (!ipc) return;
    const on = ipc.on as unknown as (channel: string, callback: (frame: LocalHostRendererFrame) => void) => void;
    on(requestChannel, listener);
  }

  public subscribePublish(listener: (frame: LocalHostCampaignPublishIpcFrame) => void): void {
    const ipc = window.playcast?.ipc;
    if (!ipc) return;
    const on = ipc.on as unknown as (channel: string, callback: (frame: LocalHostCampaignPublishIpcFrame) => void) => void;
    on(publishRequestChannel, listener);
  }

  public send(clientId: string, event: LocalEditorEvent): void {
    const ipc = window.playcast?.ipc;
    if (!ipc) return;
    const send = ipc.send as unknown as (channel: string, frame: { clientId: string; event: LocalEditorEvent }) => void;
    send(eventChannel, { clientId, event });
  }

  public sendPublishResult(result: { requestId: string; clientId: string; sessionId: string; success: boolean; error?: string }): void {
    const ipc = window.playcast?.ipc;
    if (!ipc) return;
    const send = ipc.send as unknown as (channel: string, frame: typeof result) => void;
    send(publishResultChannel, result);
  }
}
